import { errorMarkIcon } from '@/shared/ui/assets';
import { CustomTooltip } from '@/shared/ui/components';
import { zeroPad } from '@/shared/lib';
import classNames from 'classnames';
import { STUDY_HAS_ARTIFACT_REPORT_HOVER_TEXT } from './studyFidFormatter.constants';
import './styles.scss';
import type { StudyFidFormatterProps } from './studyFidFormatter.types';

const StudyFidFormatter = ({
  rma = false,
  isBiofluxDirect = false,
  hasArtifactReport = false,
  isDeleted = false,
  isTest = false,
  isAborted = false,
  isArtifact = false,
  studyId,
  handleClickStudyId,
}: StudyFidFormatterProps) => (
  <div className="study-id-formatter">
    <div className="flex items-center study-fid-item">
      {isDeleted ? (
        <span>{zeroPad(studyId)}</span>
      ) : (
        <span
          onClick={handleClickStudyId}
          className={classNames('study-id-click', isAborted ? '--aborted' : '')}
        >
          {zeroPad(studyId)}
        </span>
      )}

      <div className="flex ml-12 list-label-study-id">
        {hasArtifactReport && (
          <CustomTooltip title={STUDY_HAS_ARTIFACT_REPORT_HOVER_TEXT} placement="bottom">
            <div className={rma || isBiofluxDirect || isTest ? 'mr2' : undefined}>
              <img
                className="artifact-mark"
                id={`artifact-${studyId}`}
                src={errorMarkIcon}
                alt="Error mark icon"
              />
            </div>
          </CustomTooltip>
        )}

        {rma && <span className="rma-label">RMA</span>}

        {isTest && (
          <CustomTooltip title="Functional test study" placement="bottom">
            <span className="test-label hover-tooltip" id={`Tooltip-${studyId}`}>
              TEST
            </span>
          </CustomTooltip>
        )}

        {isArtifact && <span className="artifact-label  hover-tooltip">Artifact</span>}
      </div>
    </div>
    <div>
      {!isDeleted && isBiofluxDirect && <span className="biodirect-label">Biodirect study</span>}
    </div>
  </div>
);

export default StudyFidFormatter;
